import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail, RefreshCw } from "lucide-react";

type Props = { isOpen: boolean; onClose: () => void; onClick: () => void };

const LoginModal = ({ isOpen, onClose, onClick }: Props): JSX.Element => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="h-full max-h-full md:h-auto md:max-h-[85vh] md:max-w-md">
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-palomma-primary/10">
            <Mail className="h-6 w-6 text-palomma-primary" />
          </div>
          <DialogTitle className="text-xl font-bold">
            ¡Link enviado!
          </DialogTitle>
          <DialogDescription className="text-center text-sm text-gray-600">
            Hemos enviado un enlace mágico a tu correo. Revisa tu bandeja de entrada 
            (o carpeta de spam) y haz clic en el enlace para acceder a tu cuenta.
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="flex-col gap-4 sm:flex-col">
          <div className="flex flex-col items-center gap-2 text-sm text-gray-600">
            <p>¿No recibiste el correo?</p>
            <Button 
              variant="outline" 
              className="w-full gap-2" 
              onClick={onClick}
            >
              <RefreshCw className="h-4 w-4" />
              Volver a enviar correo
            </Button>
          </div>
          <Button 
            variant="ghost" 
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
